<template>
  <div id="UploadSlide" class="well" style="padding: 0 1em">

  <b-tabs v-model="tabIndex"
    active-nav-item-class="font-weight-bold text-uppercase text-danger"
    active-tab-class="font-weight-bold text-success"
    content-class="mt-3"
  >
    <b-tab title="上傳相片" active @click="tabIndex = 0">
     <div>
              <button
                href="#"
                @click.prevent="close()"
                class="btn btn-outline-secondary"
                type="button"
                style="font-size: 14px"
              >
                回活動花絮列表
              </button>
            </div>
            <div>
              <table class="table" style="width: 100%; align: left">
                <tbody style="width: 70%; align: left">
                  <tr class="table-success" align="left">
                    <td>
                      <div>相簿名稱:{{ $props.title }}</div>
                    </td>
                  </tr>
                   <tr  align="left">
            <td>
              <div>
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file[0]"
                  @input="fileChange(0)"
                  placeholder="上傳圖片"
                  accept="image/jpeg, image/png, image/gif"
                ></b-form-file>
                <p>檔名:{{ file[0] ? file[0].name : "" }}</p>
                 <p>檔案大小:{{ file[0] ? file[0].size/(1024*1024) : "" }}MByte</p>
              </div>
              <div slot="tip" class="el-upload__tip">
                上傳之檔案格式：
                <ul style="list-style-type: disc">
                  <li>副檔名.jpg、.png</li>
                  <li>檔案含英文字母共計 60 碼為檔名。</li>
                  <li>檔案大小不得超過4MB。</li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <b-img
                v-if="hasImage"
                :src="imageSrc"
                class="mb-3"
                fluid
                block
                rounded
              ></b-img>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddSlide()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>

    </b-tab>

  </b-tabs>
  </div>
</template>

<script>
import * as tools from '../tool'

const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export default {
  name: 'UploadSlide',
  props: ['sid', 'title'],
  components: {},
  data () {
    return {
      tabIndex: 0,
      total_rows: 0,
      per_page_rows: 3,
      cols: 5,
      rows: 1,
      image: null,
      imageSrc: null,
      mode: true,
      file: [{ name: '', RowId: '' }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        UpdateUser: null,
        sid: null,
        Info: []
      },
      inputData2: {
        imagesrc: null
      },
      currentPage: 1,
      cid: '',
      pageSize: 10
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    hasImage () {
      return !!this.image
    },
    filteredDocs: function () {
      let data = []
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    }
  },
  watch: {
    image (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value
            })
            .catch(() => {
              this.imageSrc = null
            })
        } else {
          this.imageSrc = null
        }
      }
    }
  },
  methods: {

    inputData5: function (rows) {
      this.rows = rows
      // if (rows == 1) this.rows = rows;
      // else this.rows = rows * 2;

      let data = []
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.rows - 1) * this.cols,
          this.rows * this.cols
        )
      }
      // this.currentPage =Math.ceil(this.rows/2) ;
      return data
    },

    clearImage () {
      this.image = null
    },

    fileChange (index) {
      var vm = this
      this.formData = new FormData()
      this.image = this.file[0]
      //  this.formData.delete("header");
      if (index == 0) this.formData.append('header', this.file[0])

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              vm.file[0] = response.data[0]

              this.inputData.Info[0] = response.data[0]
              //  vm.inpData.headerFile[0].codeName = vm.file[0].tempName;
              //  vm.inpData.headerFile[0].Status = 'C';
            }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },

    empty (str) {
      if (
        typeof str === 'undefined' ||
        !str ||
        str.length === 0 ||
        str === '' ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true
      } else {
        return false
      }
    },

    checkInput () {
      this.inputFlag = false

      if (this.empty(this.file[0])) {
        alert('請上傳附件')
        this.$refs['file-input'].focus()
        this.inputFlag = true
      }
    },
    AddSlide () {
      this.checkInput()
      this.inputData.UpdateUser = this.user.id
      this.inputData.sid = this.$props.sid
      const vm = this
      if (vm.inputFlag != true) {
        this.$http
          .put('./WebApi/ociaRep/AddSlide/', this.inputData)
          .then((response) => {
            if (response.data != null) {
              tools.showAlert(vm, 'success', '增加相簿圖片成功')

              vm.file[0].name = ''
              vm.file[0].RowId = ''
              vm.image = null
              vm.imageSrc = null
            } else {
              tools.showAlert(vm, 'danger', '對不起,增加相簿圖片失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },
    GetAllSlide () {
      this.inputData.UpdateUser = this.user.id
      this.inputData.sid = this.$props.sid
      const vm = this

      this.$http
        .get('./WebApi/ociaRep/GetAllSlide/'.concat(this.$props.sid))
        .then((response) => {
          if (response.data != null) {
            vm.inputData2 = response.data
            vm.total_rows = Math.ceil(vm.count2 / vm.cols)
            //  console.log(vm.inputData5);
            //   tools.showAlert(vm, "success", "增加相簿圖片成功");
          } else {
            tools.showAlert(vm, 'danger', '對不起,查詢相簿圖片失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    onContext (ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close () {
      this.$emit('hideModal')
    }

  },
  created () {
    console.log('======created UploadSlideView =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
